import {
  INIT_UIPPS,
  EDIT_UIPPS_STATUS,
  ADD_UIPPS_COORDS,
  CLEAR_UIPPS,
  UPDATE_SINGLE_UIPPS,
  ADD_NEW_UIPPS,
} from '../type';
import axiosInstance from '../../config/axios.config';
import { createSocketEmitter } from '../../utils/socketUtils/createSocketEmitter';
import { initMapMarkers } from './mapMarkers.action';
import { getValidMarkers } from '../../utils/markerValidation';
import { logSocketError } from '../../utils/socketUtils/logSocketError';

export const initUipps = (uipps) => ({
  type: INIT_UIPPS,
  payload: uipps,
});

export const updateSingle = (device) => ({
  type: UPDATE_SINGLE_UIPPS,
  payload: device,
});
export const clearUipps = () => ({
  type: CLEAR_UIPPS,
  payload: [],
});

export const addNewUipps = (device) => ({
  type: ADD_NEW_UIPPS,
  payload: device,
});

export const editUippsStatus = (device) => ({
  type: EDIT_UIPPS_STATUS,
  payload: device,
});

// запрос на получение списка uipps, с обработкой фильтрации и поиска
export const initUippsFromServer = (query) => async (dispatch, getState) => {
  try {
    // получение данных с сервера
    const result = await axiosInstance(`/api/devices/uipps${query}`);
    if (result.data && result.status === 200) {
      await dispatch(initUipps(result.data));
      return result; // Возвращаем данные для использования в .then()
    }
  } catch (error) {
    console.log(error);
  }
};

// запрос на обновление массива uipps после изменения uipps
export const initUippsAfterUpdate =
  ([updatedUipps]) =>
  async (dispatch) => {
    try {
      if (updatedUipps) {
        await dispatch(updateSingle(updatedUipps));
      }
    } catch (error) {
      console.log(error);
    }
  };

// запрос на получение одного uipps после изменения uipps
export const getOnlyOneUippsFromServer = (id) => async (dispatch) => {
  try {
    const uippsData = await axiosInstance(`/api/devices/uipps?id=${id}`);
    if (uippsData.data[0]) {
      dispatch(updateSingle(uippsData.data[0]));
    }
  } catch (error) {
    console.log(error);
  }
};


/**SOCKET */
/** Экшены - генерация событий */
// отправляем событие чтобы сервер начал слать координаты уипсов

// отправляем событие чтобы сервер начал слать координаты УИППС
export const emitGetCoordsStart = createSocketEmitter('uipps_listen_start');

// отправляем событие чтобы сервер перестал слать координаты УИППС
export const emitGetCoordsStop = createSocketEmitter('uipps_listen_stop');

// обновление стейта
export const addCoords = (coords) => ({
  type: ADD_UIPPS_COORDS,
  payload: coords,
});

/**
 * Слушает событие 'uipps_coords' и диспатчит данные в зависимости от источника.
 *
 * @param {string} source - 'map' или 'table'. По умолчанию 'table'.
 * @returns {Function} thunk с подпиской и автоматической отпиской.
 */
export const listenUippsCoords = (source = 'table') => {
  return (dispatch, getState, { socket }) => {
    socket.on('uipps_coords', ({ result, data, reason, ...rest }) => {
      if (result !== 'ok') {
        logSocketError({
          eventName: 'uipps_coords',
          payload: { result, data, reason, ...rest },
          source,
          location: 'src/redux/actions/uipps.action.js',
        });
        return;
      }

      if (!Array.isArray(data)) return;

      if (source === 'map') {
        // фильтруем валидные координаты для карты
        // Используем централизованную фильтрацию валидных маркеров
        const validMarkers = getValidMarkers(data);
        dispatch(initMapMarkers(validMarkers));
      } else {
        dispatch(addCoords(data));
      }
    });

    // Возвращаем функцию отписки
    return () => {
      socket.off('uipps_coords');
    };
  };
};
